import styled from 'styled-components';

import { BaseStyle, TabBar } from '@nhl/nhl-breakaway-ui';

export const StatsNavi = styled.ul`
    ${BaseStyle.Mixins.gaps.large};
    background: ${({ theme }) => theme.Surface.primary};
    border-bottom: 1px solid ${({ theme }) => theme.Surface.border};
    display: flex;
    align-items: end;
    justify-content: flex-start;
    list-style: none;
    margin: 0;
    overflow-x: auto;
    width: 100%;

    span {
        white-space: nowrap;
    }
`;

export const AdContainer = styled.li`
    display: flex;
    flex: auto;
    justify-content: flex-end;
`;

export const StyledTabBar = styled(TabBar)`
    border-bottom: initial;
`;
